export default "__VITE_ASSET__Chnns03___"